export const WARNING_MESSAGE_ON_APPLY = 'The end date must be greater than the start date';
